import { FBTimestamp, FirebaseDoc } from "../../common/FirebaseConfig"

export interface Clazz extends FirebaseDoc {
    name: string
    code: string
    classGrade: ClassGrade
    teacherId: string
    created: FBTimestamp
}

export enum ClassGrade {
    FIFTH = "FIFTH",
    SIXTH = "SIXTH",
}
